import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('bill.run_now'),
        action: (obj) => {
          this.onManager('performAction', {
            id: obj.id,
            managerArgs: {
              action: 'send-email',
            },
          }).then(() => {
            this.$message.success(i18n.t('message.exec_success'))
          }).catch(() => {
            this.$message.error(i18n.t('message.exec_fail'))
          })
        },
        meta: (obj) => ({
          validate: obj.enabled,
          tooltip: !obj.enabled ? i18n.t('bill.runnow.disable.tooltip') : '',
        }),
      },
      {
        label: i18n.t('system.text_153'),
        actions: obj => {
          return [
            {
              label: i18n.t('bill.text_194'),
              action: (obj) => {
                this.createDialog('SubscriptionSetDisabledDialog', {
                  columns: this.columns,
                  data: [obj],
                  onManager: this.onManager,
                  isEnabled: true,
                })
              },
              meta: (obj) => ({
                validate: !obj.enabled,
                tooltip: obj.enabled ? i18n.t('bill.subscription_validate_disable') : '',
              }),
            },
            {
              label: i18n.t('bill.text_196'),
              action: (obj) => {
                this.createDialog('SubscriptionSetDisabledDialog', {
                  columns: this.columns,
                  data: [obj],
                  onManager: this.onManager,
                })
              },
              meta: (obj) => ({
                validate: obj.enabled,
                tooltip: !obj.enabled ? i18n.t('bill.subscription_validate_enable') : '',
              }),
            },
            {
              label: i18n.t('bill.text_167'),
              action: obj => {
                this.createDialog('DeleteResDialog', {
                  vm: this,
                  data: [obj],
                  columns: this.columns,
                  title: i18n.t('bill.text_167'),
                  name: i18n.t('bill.subscription'),
                  onManager: this.onManager,
                  success: () => {
                    this.destroySidePages()
                  },
                })
              },
            },
          ]
        },
      },
    ]
  },
}
